import Single from "../../components/single/Single.tsx"
import "./user.scss"
import React from 'react'

const User = () => {
  return (
    <div className="user">
        <Single />
    </div>
  )
}

export default User